import { render } from "./Grammar.vue?vue&type=template&id=2e1c1a89&scoped=true"
import script from "./Grammar.vue?vue&type=script&lang=js"
export * from "./Grammar.vue?vue&type=script&lang=js"

import "./Grammar.vue?vue&type=style&index=0&id=2e1c1a89&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1c1a89"]])

export default __exports__